import { useEffect, useRef, useState } from 'react';
export const useWindowScroll = () => {
    const [scrollTop, setScrollTop] = useState(0);
    const isLastScrollToTop = useRef(false);
    useEffect(() => {
        const listener = () => {
            let prevScrollY = 0;
            setScrollTop((value) => {
                prevScrollY = value;
                return value;
            });
            isLastScrollToTop.current = window.scrollY < prevScrollY;
            setScrollTop(window.scrollY);
        };
        window.addEventListener('scroll', listener);
        return () => {
            window.removeEventListener('scroll', listener);
        };
    }, []);
    return { scrollTop, isLastScrollToTop: isLastScrollToTop.current };
};
export const useFocusOutside = (ref, callback) => {
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                callback();
            }
        };
        const handleFocusOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                callback();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('focusin', handleFocusOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('focusin', handleFocusOutside);
        };
    }, [ref, callback]);
};
